import {
  LIST_EXAMINATION_SUMMARY_REQUEST,
  LIST_EXAMINATION_SUMMARY_SUCCESS,
  LIST_EXAMINATION_SUMMARY_FAIL,
  LIST_EXAMINATION_SUMMARY_RESET,
  LIST_EXAMINATION_REQUEST,
  LIST_EXAMINATION_SUCCESS,
  LIST_EXAMINATION_FAIL,
  LIST_EXAMINATION_RESET,
  CREATE_EXAMINATION_REQUEST,
  CREATE_EXAMINATION_SUCCESS,
  CREATE_EXAMINATION_FAIL,
  DETAIL_EXAMINATION_REQUEST,
  DETAIL_EXAMINATION_SUCCESS,
  DETAIL_EXAMINATION_FAIL,
  UPDATE_EXAMINATION_REQUEST,
  UPDATE_EXAMINATION_SUCCESS,
  UPDATE_EXAMINATION_FAIL,
  DELETE_EXAMINATION_REQUEST,
  DELETE_EXAMINATION_SUCCESS,
  DELETE_EXAMINATION_FAIL
} from '../../constants/examinations'

const initialState = {
  loading: false,
  examinations: [],
  examination: {},
  examinationsSummary: [],
  error: null,
  pageable: {}
}

const examinationsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EXAMINATION_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_EXAMINATION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        examinationsSummary: action.payload
      }
    case LIST_EXAMINATION_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_EXAMINATION_SUMMARY_RESET:
      return { ...state, loading: false, examinationsSummary: [] }
    case LIST_EXAMINATION_REQUEST:
      return { ...state, loading: true }
    case LIST_EXAMINATION_SUCCESS:
      return { ...state, loading: false, examinations: action.payload, pageable: action.pageable }
    case LIST_EXAMINATION_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_EXAMINATION_RESET:
      return { ...state, loading: false, examinations: [] }
    case CREATE_EXAMINATION_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_EXAMINATION_SUCCESS:
      return { ...state, loadingCreate: false, examinations: [...state.examinations, action.payload] }
    case CREATE_EXAMINATION_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_EXAMINATION_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_EXAMINATION_SUCCESS:
      return { ...state, loadingDetail: false, examination: action?.payload }
    case DETAIL_EXAMINATION_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_EXAMINATION_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_EXAMINATION_SUCCESS:
      const examinationPayload = action.payload
      const examinationIndex = state.examinations.findIndex(examination => examination.id === examinationPayload.id)

      const examinationsUpdate = [...state.examinations]
      examinationsUpdate[examinationIndex] = examinationPayload

      return { ...state, loadingUpdate: false, examinations: examinationsUpdate }
    case UPDATE_EXAMINATION_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_EXAMINATION_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_EXAMINATION_SUCCESS:
      const examinationId = action.payload

      const examinationIndexDelete = state.examinations.findIndex(examination => examination.id === examinationId)
      const examinationsDelete = [...state.examinations]

      examinationsDelete.splice(examinationIndexDelete, 1)

      return { ...state, loadingDelete: false, examinations: examinationsDelete }
    case DELETE_EXAMINATION_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    default:
      return state
  }
}

export default examinationsListReducer